export default "__VITE_ASSET__Dx5L0WBQ__"